import { PropsWithChildren, ReactNode, useMemo, useState } from 'react';
import { LayoutContext, LayoutContextProps } from 'layout/context';

export type LayoutContextProviderProps = PropsWithChildren & {
  drawerOptions: ReactNode;
};

function LayoutContextProvider({
  drawerOptions,
  children,
}: LayoutContextProviderProps) {
  const [isTemporaryDrawerOpen, setIsTemporaryDrawerOpen] =
    useState<boolean>(false);

  const value = useMemo(
    (): LayoutContextProps => ({
      isTemporaryDrawerOpen,
      setIsTemporaryDrawerOpen,
      drawerOptions,
    }),
    [drawerOptions, isTemporaryDrawerOpen]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
}

export default LayoutContextProvider;
